import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'src/helper/message.service';
import { AdminService } from '../admin.service';
import { emailValidationRegx } from '../shared/static-lookups/lookup';

@Component({
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.css']
})
export class UserRegistrationComponent implements OnInit {

  isMatch: boolean = false;
  formGroup: FormGroup;
  showPassword=false;
  constructor(private fb: FormBuilder,private router: Router,
    private apiService: AdminService,private messageService: MessageService) { }

  ngOnInit(): void {
    this.showPassword=false;
    this.loadForm();
  }
  
  toggleShow()
  {
    this.showPassword = !this.showPassword;
  }

  loadForm(data? : any) {
    this.formGroup = this.fb.group({
      email:[data?.email ? data?.email : null,Validators.compose([Validators.required,Validators.pattern(emailValidationRegx), 
        Validators.maxLength(50),Validators.required])],
        firstName: [data?.firstName ? data?.firstName : null,Validators.compose([Validators.required,Validators.maxLength(50)])],
        lastName: [data?.lastName ? data?.lastName : null,Validators.compose([Validators.required,Validators.maxLength(50)])],
        password: [data?.password ? data?.password : null,Validators.compose([Validators.required,Validators.maxLength(50)])],
        confirm_password: [data?.password ? data?.password : null,Validators.compose([Validators.required,Validators.maxLength(50)])],
        church_name: [data?.church_name ? data?.church_name : null,Validators.compose([Validators.required,Validators.maxLength(50)])],
        address: [data?.address ? data?.address : null,Validators.compose([Validators.required,Validators.maxLength(500)])],
        size_of_the_church: [data?.size_of_the_church ? data?.size_of_the_church : 0,Validators.compose([Validators.required])],
      
      });
    this.matchpassword();

  }

  matchpassword() {
    this.formGroup.controls.confirm_password.valueChanges.subscribe((t) => {
      if (this.formGroup.controls.password.value != this.formGroup.controls.confirm_password.value) {
        this.isMatch = true;
      }
      else {
        this.isMatch = false;
      }
    })
    this.formGroup.controls.password.valueChanges.subscribe((t) => {
      if (this.formGroup.controls.password.value != this.formGroup.controls.confirm_password.value && this.formGroup.controls.confirm_password.value != null) {
        this.isMatch = true;
      }
      else {
        this.isMatch = false;
      }
    })
  }

  save() {
    var json = {
      firstName: this.formGroup.controls.firstName.value,
      lastName: this.formGroup.controls.lastName.value,
      email: this.formGroup.controls.email.value,
      password: this.formGroup.controls.password.value,
      confirm_password: this.formGroup.controls.password.value,
      church_name: this.formGroup.controls.church_name.value,
      address:this.formGroup.controls.address.value,
      size_of_the_church:this.formGroup.controls.size_of_the_church.value
    }

    const fd = new FormData();
    fd.append('model', JSON.stringify(json));

    if (this.formGroup.valid) {
        this.apiService.Register(fd).then(t => {
           this.messageService.successMessage('User Register successfully');
           this.router.navigate(['/session']);
        })
    }
    this.formGroup.markAllAsTouched();
  }

  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation: any, controlName: string | number): boolean {
    const control = this.formGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName: string | number): boolean {
    const control = this.formGroup.controls[controlName];
    return control.dirty || control.touched;
  }
}
